import { MultiProviderConfig, ShopType, CheckoutType } from 'types';
import { allLeadMode } from 'config';
import { ProviderConfigList } from 'config/providers';
import { DefaultTheme } from 'config/themes';

export const Demo: MultiProviderConfig = {
  name: 'Demo',
  micrositeCode: 'demo',
  shopType: ShopType.MULTI_PROVIDER,
  domain: 'updater.com',
  homepage: 'https://updater.com/internet',
  title: 'Updater Internet Shopping',
  // Phone number grabbed from Swap Target here:
  // https://app.callrail.com/settings/a/501092119/routing/calls-and-texts/numbers/378516864/edit?company_id=947929203
  fallbackPhoneNumber: '888-626-0260',
  fallbackLeadModePhoneNumber: '866-436-7680',
  defaultCheckoutType: CheckoutType.LEAD_MODE,
  defaultTheme: DefaultTheme,
  needsDcSession: false,
  updaterCrossSellActive: false,
  source: 'Demo',
  noOffersRetry: 2,
  // For now, we do not include Earthlink on updater.com/internet
  providers: ProviderConfigList.filter(
    (provider) => provider.providerCode !== 'earthlink'
  ),
  getCheckoutType: allLeadMode,
};
